// extracted by mini-css-extract-plugin
var _1 = "ReadonlyOrganizationSummary-module__animateUploadProgressBarWidth--tjz_L";
var _2 = "ReadonlyOrganizationSummary-module__animatedBackground--Lroph";
var _3 = "ReadonlyOrganizationSummary-module__container--zCO__";
var _4 = "ReadonlyOrganizationSummary-module__header--EVryK";
var _5 = "ReadonlyOrganizationSummary-module__overflowMenu--OnaGu";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "header", _5 as "overflowMenu" }
